<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Setting Menu Authorization 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="saveMenu()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
        <b-col cols="4">
            <b-input-group>
                    <b-input-group-prepend><span class="pt-2 pr-2">Modul Name</span></b-input-group-prepend>
                    <b-form-select v-model="filter.modulname" :plain="true" :options="modules" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-input-group >
              <b-input-group-prepend><span class="pt-2 pr-2">User Name</span></b-input-group-prepend>
              <b-form-input readonly v-model="filter.username" placeholder="Select User !" ></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuUserShow=true">
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table style="width: 100%;">
            <thead>
                <tr>
                    <th width="40"></th>
                    <th>Menu Name</th>
                    <th width="40">C</th>
                    <th width="40">R</th>
                    <th width="40">U</th>
                    <th width="40">D</th>
                    <th width="40">P</th>
                    <th width="40">O</th>
                    <th width="40">ALL</th>
                    <th width="90">Permission</th>
                </tr>
            </thead>
            <tbody>
                  <tr v-for="menu in menuLines" :key="menu.name" :class="menu.cssClass" >
                    <td><div v-if="menu.selected"><i class="fa fa-check"></i></div></td>
                    <td class="display"><span v-html="menu.display"></span></td>
                    <td class="link" @click="checkPemission(menu, 'C')"><div style="padding:0" v-if="menu.C == 'C'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'R')"><div style="padding:0" v-if="menu.R == 'R'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'U')"><div style="padding:0" v-if="menu.U == 'U'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'D')"><div style="padding:0" v-if="menu.D == 'D'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'P')"><div style="padding:0" v-if="menu.P == 'P'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'O')"><div style="padding:0" v-if="menu.O == 'O'"><i class="fa fa-check"></i></div></td>
                    <td class="link" @click="checkPemission(menu, 'ALL')"><div style="padding:0" v-if="menu.ALL"><i class="fa fa-check"></i></div></td>
                    <td><div style="color:#000099"><em>{{ menu.cssClass == 'header' ? '' : menu.permission }}</em></div></td>
                </tr>
            </tbody>
          </table>
      </div>
      <b-row align-h="between" class="mt-4">
        <b-col cols="4">
            <button class="btn btn-primary mr-1" @click="saveMenu()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </b-col>
        <b-col cols="4">
          <div class="text-right">
            <button class="btn btn-primary mr-1" @click="selectAll()">
              <i class="fa fa-check"></i> Select All
            </button>
            <button class="btn btn-primary mr-1" @click="clearAll()">
              Clear All
            </button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
   <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid #D1D1D1;
                padding: 0 10px;
                height: 25px;
                i {
                    margin-top: 7px !important;
                    position: inherit !important;
                }                
            }
            
            td.display {
                text-align: left;
            }

            tr.header{
                td.link {
                    background-color: #eee;
                    i.fa-check {
                        display: none;
                    }                    
                }
            }

            tr.detail {
              td.link {
                cursor: pointer;
              }
              .link:hover {
                  background-color: rgba(250,250,0,1);
              }                      
            }
        }
    }
 
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuUser from "../lookup/lkuUser";
import toastr from "mini-toastr";
import auth from "../../apis/auth";

toastr.init();

export default {
  data() {
    return {
      showFilter: false,
      showReport: false,
      reportUrl: null,
      horizontal: true,
      modules:[],
      lkuUserShow:false,
      isLoading:false,
      filter:{},
      menuLines : []
    };
  },
  components: { lkuUser,Loading },  
  computed:{
        modulname() {
            return this.filter.modulname;
        }
    },
  // watch:{
  //       modulname: async function(newval) {
  //         if (this.filter.username) 
  //         {
  //           const menuChange = this.menuLines.filter(m => m.selected==1);
  //           if (menuChange.length > 0){
  //               toastr.warn('Your Change is discharged (not saved)');
  //           } 
  //           this.getData();
  //         }
  //       }
  //   },  
  created: async function (){
      const list = await auth.apps();
      this.modules = list.reduce((newArr,item) =>{
            newArr.push({value: item.code, text:item.name});
            return newArr;
        },[]);
      const { user } = this.$store.state;
    if ((this.$route.params.modulname) && (this.$route.params.username))  {
        this.filter.modulname=this.$route.params.modulname;
        this.filter.username=this.$route.params.username;
          this.getData();
    } 
    this.$watch('modulname', function(newVal) {
          if (this.filter.username) 
          {
            const menuChange = this.menuLines.filter(m => m.selected==1);
            if (menuChange.length > 0){
                toastr.warn('Your Change is discharged (not saved)');
            } 
            this.getData();
          }
    });            

  },
  methods: {
    getData: async function(ctx) {
        this.isLoading=true;
        this.menuLines = await auth.menuuser(this.filter);      
        this.isLoading=false;      
    },
    checkPemission : function(menu, code) {
        if (menu.cssClass == 'detail') {
            if (code.length == 1) {
                menu[code] = (menu[code] != code) ? code : '';
            } else {
                if (code == 'ALL') {
                    if (menu.ALL) {
                        menu.C = '';
                        menu.R = '';
                        menu.U = '';
                        menu.D = '';
                        menu.P = '';
                        menu.O = '';
                        menu.ALL = false;
                    } else {
                        menu.C = 'C';
                        menu.R = 'R';
                        menu.U = 'U';
                        menu.D = 'D';
                        menu.P = 'P';
                        menu.O = 'O';
                        menu.ALL = true;
                    }
                }
                menu.selected = 1;
            }
            this.syncPermission(this.menuLines, menu);
        }
    },
    syncPermission:function (data, row) {
        row.permission = row.C + row.R + row.U + row.D + row.P + row.O;
        row.selected = (row.permission.length > 0) ? 1 : 0;
        row.ALL = (row.permission == 'CRUDPO');
        let _list;
        var _level = row.level;
        var _headr = row.parent_id;
        for (var i = _level; i > 1; i-= 1) {          
            var _header = data.find(i => i.name === _headr);
            if (row.selected) {
                _header.selected = 1;
            } else {
                _list = data.filter(m => ((m.parent_id === _header.name)&&(m.selected===1)));
                _header.selected = (_list.length > 0) ? 1 : 0;
            }
            _headr = _header.parent_id;
        }
        // xg.toolbar.show('update', 'undo');
    },
    saveMenu: async function(){
      try {
        this.isLoading=true;
        // await auth.menusave({modulname:this.filter.modulname, username:this.filter.username, lines:this.menuLines.filter(m => m.selected==1)});
        await auth.menusave({modulname:this.filter.modulname, username:this.filter.username, lines:this.menuLines.filter(m => (m.permission))});
        this.menuLines.forEach((item) => item.selected = 0);            
          toastr.success('Data Saved Successfully');
        this.isLoading=false;
      } catch (error) {
          this.isLoading=false;
          if (error.message) {
              toastr.error(error.message);
          } else {
              toastr.error(JSON.stringify(error));
          }
      }
    },
    close(){
      router.push("home");
    },
    selectAll : function () {
        this.menuLines.forEach((item,idx) => {
          if (item.cssClass !== 'header') {
            item.C = 'C';
            item.R = 'R';
            item.U = 'U';
            item.D = 'D';
            item.P = 'P';
            item.O = 'O';
            item.ALL = true;
          item.permission = 'CRUDPO';
          item.selected = 1;
          }
        });            
    },
    clearAll : function () {
        this.menuLines.forEach((item,idx) => {
          item.C = '';
          item.R = '';
          item.U = '';
          item.D = '';
          item.P = '';
          item.O = '';
          item.ALL = false;
          item.permission = '';
          item.selected = 1;

        });            
    },
    onSelectUser(_selected) {
        this.filter.username = _selected.username;
        this.filter.full_name = _selected.full_name;
        this.lkuUserShow=false;
        if (this.filter.modulname) {
            const menuChange = this.menuLines.filter(m => m.selected==1);
            if (menuChange.length > 0){
                toastr.warn('Your Change is discharged (not saved)');
            } 
            this.getData();
        }
    },
  }
};
</script>
